import { QUEST_DESC_1, QUEST_DESC_2 } from '../helpers/content';
import {
	ContentWrapper,
	ContentContainer,
	ContentTitle,
	ContentDesctiptionBonus
} from './ContentStyled';
import quest from '../assets/features/quest.png';
import { QuestIcon } from './items/Items';
import QuestItem from './items/QuestItem';

export default function Quest({ dimentions }) {
	return (
		<ContentWrapper>
			<ContentContainer>
				<div style={{ margin: 'auto' }}>
					<ContentTitle scale={dimentions.scale}>Weekly Quest</ContentTitle>
				</div>
			</ContentContainer>
			<div style={{ margin: 'auto' }}>
				<ContentDesctiptionBonus scale={dimentions.scale}>
					{QUEST_DESC_1()}
					<QuestIcon scale={dimentions.scale}>
						<img src={quest} alt='quest' />
					</QuestIcon>
					{QUEST_DESC_2()}
					<QuestItem scale={dimentions.scale} />
				</ContentDesctiptionBonus>
			</div>
		</ContentWrapper>
	);
}
